module.exports = __webpack_public_path__ + "img/style_model_preview_679.c5482fdd.jpg";